import { Modal, Select } from "antd"
import { useAppDispatch, useAppSelector } from "../../../hooks/hooks"
import { useEffect } from "react"
import { selectAgentInfo } from "../../home/homeSlice"
import { cancelForwardAction, chooseForwardChannel, resetChatState, resetPrivateChatInitState, selectForwardingState, selectInputNote, selectSelectedSessionId } from "../privateSessionSlice"
import { forwardPrivateSession, requestAndForwardPrivateSession } from "../privateSessionActions"
import { setStorageActiveMenuID } from "../../../utils/localStorage/menu"
import { useNavigate } from "react-router-dom"
import { resetActiveChatFromStorage } from "../../../utils/localStorage/activeChat"

const PrivateSessionForwardModal = () => {

    const dispatch = useAppDispatch()
    const forwardingState = useAppSelector(selectForwardingState)
    const agentInfo = useAppSelector(selectAgentInfo)
    const selectedSessionId = useAppSelector(selectSelectedSessionId)
    const inputNote = useAppSelector(selectInputNote)

    const navigate = useNavigate()

    // choose forward channel
    const handleChooseForwardChannel = (channel) => {
        dispatch(chooseForwardChannel(channel))
    }

    const toLobbyPage = () => {
        setStorageActiveMenuID('1')
        navigate('/')
        resetActiveChatFromStorage()
    }
    // confirm forward
    const handleConfirmForward = () => {
        dispatch(forwardPrivateSession({
            sessionId: selectedSessionId,
            additionalInfo: inputNote,
            forwardingChannel: forwardingState.channelSelected
        }))

        dispatch(resetPrivateChatInitState())
        toLobbyPage()
    
        // dispatch(requestSessionForLobby({session_id: selectedSessionId}))
    }
    // cancel forward
    const handleCancelForward = () => {
        dispatch(cancelForwardAction())
    }

    // prevent handle case ซ้ำ
    useEffect(() => {
        
    }, [])

    // success forward
    useEffect(() => {
        console.log(agentInfo)
    }, [])

    return (<>
        <Modal title="Forward the chat"
            visible={forwardingState.isClicked}
            onOk={handleConfirmForward}
            onCancel={handleCancelForward}>
            <p>Forward to</p>
            <Select onChange={handleChooseForwardChannel} style={{ width: '100%' }}>
                {
                    agentInfo?.data?.forwarded_channel?.map((channel, i) => {
                        return (
                            <Select.Option key={i} value={channel}>{channel}</Select.Option>
                        )
                    })
                }
            </Select>
        </Modal >
    </>

    )
}
export default PrivateSessionForwardModal